import "./RootCanalTreatment.module.css";
import Header from "@/reusable_sections/Header";
import KanalTedavisiHakkinda from "./sections/KanalTedavisiHakkinda";
import TreatmentProcess from "./sections/TreatmentProcess";
import RandevuAl from "./sections/RandevuAl";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function RootCanalTreatmentPage() {
  return <div>
      <Header />
      <KanalTedavisiHakkinda />
      <TreatmentProcess />
      <RandevuAl />
      <Projects />
      <Footer />
    </div>;
}